<template>
  <div style="background-color: white; height: 100vh;">
    <div class="row">
      <div class="col-md-6">
        <img src="static\img\icon.jpeg" width="100%" alt="">
      </div>
      <div class="col-md-6">
        <div class="container-fluid">

          <div class="row mt-5">
            <div class="col-md-12">
              <h3>Menu Transit</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button @click="openSearch" class="btn btn-primary btn-lg btn-block mt-2">
                <i class="fa fa-search"></i>
                Cari Permohonan
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button @click="openNew" class="btn btn-primary btn-lg btn-block mt-2">
                <i class="fa fa-edit"></i>
                Ajukan Permohonan
              </button>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-12">
              <b-collapse v-model="collapse" id="collapse">
                <div v-if="modelCollapse === 'search'" class="input-group">
                  <input type="text" class="form-control" placeholder="Masukkan Kode Registrasi" v-model="kodeRegistrasi"
                    style="font-size: 20px; padding: 10px; height: 50px;">
                  <div class="input-group-button">
                    <button @click="getPdf" class="btn btn-primary btn-lg" type="button"><i class="fa fa-search"></i></button>
                  </div>
                </div>
                <div v-if="modelCollapse === 'new'" class="row">
                  <div class="col-md-6">
                    <button @click="routeToPenumpang" class="btn btn-success btn-lg btn-block" style="height: 100px;"><i class="fa fa-user"></i>
                      Barang Bawaan Penumpang</button>
                  </div>
                  <div class="col-md-6">
                    <button title="konten belum tersedia" class="btn btn-success btn-lg btn-block" disabled style="height: 100px;"><i
                        class=""></i> COMING SOON!!</button>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
@page {
  background: white;
}
</style>
<script>
import swal from 'sweetalert'
export default {
  data () {
    return {
      collapse: false,
      modelCollapse: '',
      kodeRegistrasi: ''
    }
  },
  methods: {
    openSearch () {
      if (this.collapse === true && this.modelCollapse === 'new') {
        this.collapse = true
        this.modelCollapse = 'search'
      } else {
        this.collapse = !this.collapse
        this.modelCollapse = 'search'
      }
    },
    openNew () {
      if (this.collapse === true && this.modelCollapse === 'search') {
        this.collapse = true
        this.modelCollapse = 'new'
      } else {
        this.collapse = !this.collapse
        this.modelCollapse = 'new'
      }
    },
    routeToPenumpang () {
      this.$router.push('/formtransit')
    },
    getPdf () {
      this.$http.get('transit/getpdf/' + this.kodeRegistrasi).then((response) => {
        if (response.data.status === 'error') {
          swal(response.data.status, response.data.message, response.data.icon)
        } else {
          window.open(this.$http.options.base + '/api/transit/viewpdf/' + response.data.id_transit)
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/transit/MenuTransit.vue?9ee49a8a